var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55536 4.88887V3.33335C9.55536 2.9208 9.39147 2.52515 9.09976 2.23343C8.80804 1.94172 8.41239 1.77783 7.99984 1.77783H2.55552C2.14297 1.77783 1.74732 1.94172 1.4556 2.23343C1.16388 2.52515 1 2.9208 1 3.33335V12.6665C1 13.079 1.16388 13.4747 1.4556 13.7664C1.74732 14.0581 2.14297 14.222 2.55552 14.222H7.99984C8.41239 14.222 8.80804 14.0581 9.09976 13.7664C9.39147 13.4747 9.55536 13.079 9.55536 12.6665V11.1109",
    stroke: "#FF4444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 8.00003H14.9999L12.6666 5.66675",
    stroke: "#FF4444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.333L15 7.99976",
    stroke: "#FF4444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.bc36be91af7730a938b7f226b55b1bf7.svg";
export { ForwardRef as ReactComponent };